// A thin wrapper for browser Storage that "just works" with in-memory fallback
// https://michalzalecki.com/why-using-localStorage-directly-is-a-bad-idea/

class Storage {
  constructor(storageType) {
    this.persistentStorage = Storage.getPersistentStorage(storageType)
    if (!this.persistentStorage) {
      this.ephemeralStorage = {}
    }
  }

  getItem(key) {
    if (this.persistentStorage) {
      return this.persistentStorage.getItem(key)
    }
    return this.ephemeralStorage[key] || null
  }

  setItem(key, value) {
    if (this.persistentStorage) {
      this.persistentStorage.setItem(key, value)
    } else {
      this.ephemeralStorage[key] = String(value)
    }
  }

  removeItem(key) {
    if (this.persistentStorage) {
      this.persistentStorage.removeItem(key)
    } else {
      delete this.ephemeralStorage[key]
    }
  }

  clear() {
    if (this.persistentStorage) {
      this.persistentStorage.clear()
    } else {
      this.ephemeralStorage = {}
    }
  }

  isPersistent() {
    return !!this.persistentStorage
  }

  static getPersistentStorage(storageType) {
    // Adapted from MDN "Using the Web Storage API" example
    // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Testing_for_availability
    try {
      const storage = window[storageType]
      const STORAGE_TEST_KEY = '__STORAGE_TEST_KEY__'
      storage.setItem(STORAGE_TEST_KEY, STORAGE_TEST_KEY)
      storage.removeItem(STORAGE_TEST_KEY)
      return storage
    } catch (e) {
      return null
    }
  }
}

module.exports = Object.assign(Storage, {
  localStorage: new Storage('localStorage'),
  sessionStorage: new Storage('sessionStorage')
})
